
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/converter/keynote-to-xd",
      function () {
        return require("private-next-pages/converter/keynote-to-xd.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/converter/keynote-to-xd"])
      });
    }
  